import { useSyncExternalStore } from 'react';

let cachedScrollbarWidth: number | undefined;

function measureScrollbarWidth(): number {
  if (cachedScrollbarWidth !== undefined) {
    return cachedScrollbarWidth;
  }

  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  cachedScrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.remove();

  return cachedScrollbarWidth;
}

function subscribe(): () => void {
  return () => {};
}

function getSnapshot(): number {
  return measureScrollbarWidth();
}

function getServerSnapshot(): number {
  return 0;
}

export function useScrollbarWidth(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
